import { HttpError, useCreate } from '@refinedev/core';

type GenerateMeetingAgendaInput = {
  templateId: string;
};

type UseGenerateCalendarEventMeetingAgendaResult = {
  generateMeetingAgenda: (input: GenerateMeetingAgendaInput) => Promise<void>;
  isLoading: boolean;
  error: HttpError | null;
};

export const useGenerateCalendarEventMeetingAgenda = (
  eventId: string,
): UseGenerateCalendarEventMeetingAgendaResult => {
  const { mutateAsync, error, isLoading } = useCreate<GenerateMeetingAgendaInput>({
    resource: `calendar-events/${eventId}/meeting-agenda`,
  });

  const generateMeetingAgenda = async (input: GenerateMeetingAgendaInput) => {
    await mutateAsync({
      values: input,
    });
  };

  return {
    generateMeetingAgenda,
    isLoading,
    error,
  };
};
